// extracted by mini-css-extract-plugin
export default {"helpIcon":"Label_helpIcon__92yRa","label":"Label_label__Hr3eV","tooltip":"Label_tooltip__QM983","help":"Label_help__ulYmz"};